<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Update Sample">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit sample'">
      <template #gated-content>
        <sample-form :sample="sample" @submit="submit"></sample-form>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleForm from "@/components/lab/sample/SampleForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getCollection, getModel } from "@/shared/fetch-utils";
import SampleAnalytesModel from "@/models/lab/SampleAnalytesModel";

const SampleRepository = LabRepositoryFactory.get("sample");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleForm,
  },
  data() {
    return {
      loading: true,
      sample_id: this.$route.params.sample_id || null,
      sample: null,
      sample_analytes: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/samples",
            title: "Sample list",
          },
          {
            icon: "fa-eye",
            linkto: `/samples/${this.sample_id}`,
            title: "View sample",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data, new_analytes, existing_analytes) {
      try {
        await SampleRepository.update(this.sample_id, form_data);

        new_analytes.forEach(async ({ analyte }) => {
          const model = new SampleAnalytesModel({
            sample_id: this.sample_id,
            analyte_id: analyte.id,
          })
          await model.save()
        })

        existing_analytes.forEach(async (item) => {
          if (item.delete) {
            const sample_analyte = this.sample_analytes.find((analyte) => analyte.analyte_id === item.analyte.id)
            const sample_analyte_id = sample_analyte ? sample_analyte.id : null
            if (!sample_analyte_id) return

            const model = new SampleAnalytesModel({ id: sample_analyte_id })
            await model.delete()
          }
        })

        this.editSuccess();
        this.$router.push(`/samples/${this.sample_id}`);
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.sample = await getModel({
      model_type: "sample",
      id: this.sample_id,
      message: this.$bvToast,
    });

    this.sample_analytes = await getCollection({
      collection_type: "sample_analytes",
      filters: [
        {
          logic: "filterEquals",
          field: "sample_id",
          value: this.sample_id
        }
      ]
    })

    this.loading = false;
  },
  notifications: sampleNotifications,
};
</script>
